import Beleave from "../components/Beleave";
import useBeleave from "../hooks/useBeleave";

const BeleavePages = () => {
    const AllBeleaveProps = useBeleave();
    return <Beleave {...AllBeleaveProps}/>
};

export default BeleavePages;